var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      ref: "modal",
      on: {
        hide: function ($event) {
          return _vm.$emit("input", null)
        },
      },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function () {
            return [_vm._v(_vm._s(_vm.$t("forms.howtomodal.howto")))]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _vm.exercise
        ? [
            _c("h3", { staticClass: "title is-4 is-size-5-mobile mb-3" }, [
              _vm._v(_vm._s(_vm.exercise.name)),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "field is-grouped is-grouped-multiline mb-1" },
              [
                _c("div", { staticClass: "control" }, [
                  _c("div", { staticClass: "tags has-addons" }, [
                    _c("span", { staticClass: "tag" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("forms.howtomodal.bodypart")) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "tag is-primary" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("enums.bodypart." + _vm.exercise.bodypart)
                          ) +
                          "\n          "
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "control" }, [
                  _c("div", { staticClass: "tags has-addons" }, [
                    _c("span", { staticClass: "tag" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("forms.howtomodal.category")) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "tag is-primary" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("enums.category." + _vm.exercise.category)
                          ) +
                          "\n          "
                      ),
                    ]),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "columns is-mobile is-multiline" },
              _vm._l(_vm.exercise.images, function (image_url, sequenceIndex) {
                return _c("div", { staticClass: "column is-half" }, [
                  _c("h3", { staticClass: "subtitle is-5 mb-1" }, [
                    _vm._v(
                      "\n          " + _vm._s(sequenceIndex + 1) + "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("figure", { staticClass: "image is-square" }, [
                    _c("img", {
                      attrs: {
                        src: image_url,
                        alt:
                          _vm.exercise.name + " - Image " + (sequenceIndex + 1),
                      },
                    }),
                  ]),
                ])
              }),
              0
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }